import React from "react";
import "./Showsub1.css";
import { Link } from "react-router-dom";
import ProductItems from "../Data/Productitems";

const MediaProductDropdown = ({ handleClose }) => {
  return (
    <ul className="drop_down_cont_media">
      {ProductItems.map((item, index) => (
        <li key={index}>
          <Link
            className={item.cName}
            to={item.path}
            onClick={handleClose}
            style={{ color: "#ff635e" }}
          >
            {item.title}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default MediaProductDropdown;